import { all } from 'redux-saga/effects';
// import { authWatch.erSaga } from './utils/authSaga/authSaga';
// import { kitchenWatcherSaga } from './utils/kitchenSaga/kitchenSaga/kitchenSaga';
import { kitchenComplaintWatcherSaga } from './utils/kitchenSaga/kitchenComplaintSaga/kitchenComplaintSaga';
import { kitchenSettingsWatcherSaga } from './utils/kitchenSaga/kitchenSettingsSaga/kitchenSettingsSaga';
import { settingsCatalogsWatcherSaga } from './utils/settingsSaga/settingsCatalogsSaga/settingsCatalogsSaga';
import { deliveryServicesWatcherSaga } from './utils/deliverySaga/deliveryServicesSaga/deliveryServicesSaga';
import { clientsSearchWatcherSaga } from './utils/clientsSaga/clientsSearchSaga/clientsSearchSaga';
import { clientsNotificationsWatcherSaga } from './utils/clientsSaga/clientsNotificationsSaga/clientsNotificationsSaga';
import { addressesSearchWatcherSaga } from './utils/clientsSaga/addressesSearchSaga/addressesSearchSaga';
import { financeWalletsWatcherSaga } from './utils/financeSaga/financeWalletsSaga/financeWalletsSaga';
import { financePromocodesWatcherSaga } from './utils/financeSaga/financePromocodesSaga/financePromocodesSaga';
import { financeCorpclientsWatcherSaga } from './utils/financeSaga/financeCorpclientsSaga/financeCorpclientsSaga';
import { servicesWatcherSaga } from './utils/servicesSaga/servicesSaga/servicesSaga';
import { servicesLogsWatcherSaga } from './utils/servicesSaga/servicesLogsSaga/servicesLogsSaga';

export default function* combineSaga() {
  yield all([
    // authWatcherSaga(),
    // kitchenWatcherSaga(),
    kitchenComplaintWatcherSaga(),
    kitchenSettingsWatcherSaga(),
    settingsCatalogsWatcherSaga(),
    deliveryServicesWatcherSaga(),
    clientsSearchWatcherSaga(),
    clientsNotificationsWatcherSaga(),
    addressesSearchWatcherSaga(),
    financeWalletsWatcherSaga(),
    financePromocodesWatcherSaga(),
    financeCorpclientsWatcherSaga(),
    servicesWatcherSaga(),
    servicesLogsWatcherSaga(),
  ]);
}
